<script>
    import Route, {router} from "./lib/Router/Router.svelte";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import charges from "./stores/charges";
    import clocking from "./stores/clocking";
    import Login from "./components/pages/Login.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Tasks from "./tasks/Tasks.svelte";
    import Projects from "./projects/Projects.svelte";
    import Clients from "./clients/Clients.svelte";
    import Services from "./services/Services.svelte";
    import Charges from "./charges/Charges.svelte";
    import WorkspaceServices from "./workspace/WorkspaceServices.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Dashboard from "./workspace/Dashboard.svelte";
    import ChargeModal from "./charges/ChargeModal.svelte";
    import TodoSidebar from "./todo/TodoSidebar.svelte";
    // import ClockingTaskModal from "./tasks/ClockingTaskModal.svelte";
    import UserAccount from "./workspace/account/UserAccount.svelte";
    import Users from "./workspace/users/Users.svelte";
    import Notifications from "./notifications/Notifications.svelte";

    let userInitialized = false;
    let appInitialized = false;
    let showLogin = false;

    let clockingTimer;
    let documentTitle = document.title;
    let appTimer = null;
    let hiddenSecondsPassed = 0;


    const onDocumentVisibilityChange = () => {
        console.log("onDocumentVisibilityChange", document.visibilityState);
        if (document.visibilityState === 'hidden') {
            appTimer = setInterval(() => {
                hiddenSecondsPassed++;
            }, 1000);
        } else {
            if (hiddenSecondsPassed > 5) {
                collect();
            }
            if (appTimer) {
                clearInterval(appTimer);
                appTimer = null;
                hiddenSecondsPassed = 0;
            }
        }
    }

    const collect = () => {
        const onSuccess = result => {
            if (result.clocking_task) {
                clocking.setTask(result.clocking_task);
            } else {
                clocking.clear();
            }

            $app.todos = ~~result.todo;
        }

        const onFailure = err => {
        };

        R.handle(R.workspace.collect, [], onSuccess, onFailure);
    }

    const initUser = async () => {
        userInitialized = true;
        user.initialize();
    }

    const appInitialize = () => {

        const onSuccess = result => {
            $user.id = result.user.id;
            $user.name = result.user.name;
            $user.email = result.user.email;
            $user.color = result.user.color;

            // get current workspace
            let path = router.url.split("/");
            // if (path.length > 2) {
            //     $user.wsId = path[2];
            // }

            if (result.clocking_task) {
                clocking.setTask(result.clocking_task);
            }

            $app.users = result.users;
            $app.viewBy = $user.id;
            $app.todos = ~~result.todo;

            document.addEventListener('visibilitychange', onDocumentVisibilityChange);
            appInitialized = true;

            // if (!$user.wsId) {
            //     $user.wsId = result.workspaces[0].slug;
            //     router.go(`/app/${$user.wsId}`)();
            // }
        }

        const onFailure = err => {
        };

        R.handle(R.workspace.initialize, [], onSuccess, onFailure);
    }

    initUser();

    clockingTimer = setInterval(() => {
        // clocking.setDuration();
        if (clocking.onProgress()) {
            $clocking.task.duration = new Date() - $clocking.task.date;
            document.title = `${documentTitle} - ${clocking.getDurationString()}`;
        } else {
            document.title = documentTitle;
        }
    }, 1000);

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    $: if (userInitialized) {
        if (!$user.token) {
            showLogin = true;
        } else if (!appInitialized) {
            appInitialize();
        }
    }
</script>


{#if userInitialized && !$user.token}
    <Login/>
{/if}
{#if appInitialized}
    <PageLoader/>
    <PopupLoader/>
    <AppHeader/>
    <AppMenu/>
    <main>
        <div class="app-main-content">
            <div class="container-fluid">
                <Route match="/">
                    <Route match="app">
                        <Route exact>
                            <Dashboard/>
                        </Route>
                        <Route match="task">
                            <Tasks/>
                        </Route>
                        <Route match="project">
                            <Projects/>
                        </Route>
                        <Route match="client">
                            <Clients/>
                        </Route>
                        <Route match="services">
                            <Services/>
                        </Route>
                        <Route match="charges">
                            <Charges/>
                        </Route>
                        <Route match="ws-service">
                            <WorkspaceServices/>
                        </Route>
                        <Route match="notifications">
                            <Notifications/>
                        </Route>
                        <!--                                    <Route match="workspace">-->
                        <!--                                        <Route exact>-->
                        <!--                                            <Workspace {ws}/>-->
                        <!--                                        </Route>-->
                        <!--                                        <Route match="wsservice">-->
                        <!--                                            <WorkspaceServices {ws}/>-->
                        <!--                                        </Route>-->
                        <!--                                    </Route>-->
                        <Route match="my-account">
                            <UserAccount/>
                        </Route>
                        <Route match="users">
                            <Users/>
                        </Route>
                    </Route>
                </Route>
            </div>
        </div>
    </main>
{/if}
<TodoSidebar/>
{#if $charges.charge != null}
    <ChargeModal/>
{/if}
<!--{#if $clocking.showTaskModal}-->
<!--    <ClockingTaskModal/>-->
<!--{/if}-->

<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main {
            padding-left: 50px;
        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main {
            padding-left: var(--aside-width);
        }

        main .app-main-content {
            padding: 30px 10px 20px 10px;
        }
    }
</style>